// @owners { team: patients }
import { type Brand } from '@alto/design-system';
import { Platform } from 'react-native';
import { images as altoImages } from './index';

type Images = typeof import('./index').images;

export async function loadImages(brand: Brand): Promise<Images> {
  switch (brand) {
    case 'fuzehealth':
      // webpack: /* webpackChunkName: "images-fuzehealth" */
      return (await import('./fuzehealth')).images;
    case 'alto':
    default:
      // webpack: /* webpackChunkName: "images-alto" */
      return (await import('./index')).images;
  }
}

// On android, dynamic imports are fully not supported so set IMAGES to altoImages so images render
let IMAGES = Platform.OS === 'web' ? ({} as Record<string, never>) : altoImages;
export const setImages = (images: Images) => {
  IMAGES = images;
};

export const getImage = (imageName: keyof Images) => {
  return IMAGES[imageName];
};
